export default "__VITE_ASSET__33302443__"